// @ts-nocheck
import React, { useState } from "react";
import axios from "axios";
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import { CloseButton } from "../Componentes/feedback/dialog/CloseButton";
import { BotonVerde } from "../Difusiones/Componentes/BotonVerde";
import { Form } from "../Componentes/useForm";
import { SIZE_MD, URL_API_SIA } from "../Contantes/Constantes";
import { useAreas } from "./State/AreasContext";
import { TextFieldRojo } from "../App";
import FormInput from "../Componentes/FormInput";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import Joi from "joi";
import FormInputMultiline from "../Componentes/FormInputMultiline";
import { setupInterceptorsTo } from "../Componentes/API/AxiosBuilder";
import { IconButton, InputAdornment } from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import { DialogContent as ModalContent } from '@mui/material';
import SinapTheme from "../styles/SinapTheme";
import useMediaQuery from '@mui/material/useMediaQuery';
import { DialogActions as ModalActions } from '@mui/material';
import { useBody } from "../Body/state/BodyContext";
import { SaveButton } from "../Componentes/inputs/SaveButton";
import AlertMessage from "../Alias/AlertMessage";
import ConfirmarNoReplyDuplicado from "./Componentes/ConfirmarNoReplyDuplicado";
import CamposNoReply from "./Componentes/CamposNoReply";
import Zoom from '@mui/material/Zoom';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const useStyles = makeStyles(theme => ({
    typography: {
        width: '100%',
        padding: '3%',
        color: SinapTheme.palette.primary.main,
    },
    grid: {
        '@media (max-width: 1200px)': {
            width: '120%',
            height: '100%',
        },
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-start',
        '& > *': {
            margin: '8px',
        },
        flexGrow: 1,
        maxWidth: 752,
    },
    texto: {
        '@media (max-width: 900px)': {
            fontSize: '80%',
        },
    },
    typography: {
        width: "80%",
        padding: "3%",
        color: SinapTheme.palette.primary.main,
    },
}));

const styleLista = {
    width: '80%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
}

export const AgregarAreas = ({ onClose, areaPadre, handleUpdate, ...props }) => {
    const { getAreas, value, setValue, handleChangeI, handleChangeO, handleChangeTN, handleChangeTD,
        handleClickRemoveIntegrante, handleClickAddIntegrante,
        handleClickRemoveOficina, handleClickAddOficina,
        handleClickRemoveInterno, handleClickAddInterno,
        integrantes, oficina, numero, especificacion,
        alertOficina, setAlertOficina,
        alertInterno, setAlertInterno, } = useAreas();
    const { setMessage, setSuccess } = useBody();
    const [errores, setErrores] = useState([]);
    const [loading, setLoading] = useState(false);
    const [conflictoNoReply, setConflictoNoReply] = useState(null);
    const matches = useMediaQuery('(max-width:600px)');
    const internoInicial = { numero: '', especificacion: '' };


    const classes = useStyles();
    const axiosInstance = setupInterceptorsTo(axios.create());

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        if (integrantes !== '') { setMessage('Debe pulsar el + para guardar el  integrante'); setLoading(false); return; }
        else if (oficina !== '') { setMessage('Debe pulsar el + para guardar el  el numero de oficina'); setLoading(false); return; }
        else if (numero !== '') { setMessage('Debe pulsar el + para guardar el  el interno '); setLoading(false); return; }
        else if (especificacion !== '') { setMessage('Debe pulsar el + para guardar el  el interno'); setLoading(false); return; }
        if (value.nombre.includes('/')) { setMessage('El nombre no puede contener el carácter "/"'); setLoading(false); return; }
        let error = validateForm();
        if (error) {
            mensajeAlertaFalloFormulario(error);
            setLoading(false);
            return;
        }
        let inter = value.internos.filter((i) => { return i.numero !== '' })
            .map((i) => {
                return 'numero:' + i.numero + ';especificacion:' + i.especificacion;
            })
        let body = {
            path: areaPadre.path + '/' + value.nombre,
            nombre: value.nombre,
            integrantes: value.integrantes,
            observaciones: value.observaciones,
            internos: inter,
            oficinas: value.oficinas.filter((o) => { return o !== '' }),
            noReply: value.noReply ?? [],
        }
        crearArea(body);
    }

    const crearArea = (body, confirmarDuplicado = false) => {
        setLoading(true);
        axiosInstance({
            method: 'POST',
            url: URL_API_SIA + "/areas/area",
            data: { ...body, confirmarDuplicado }
        })
            .then(() => {
                setSuccess("El área fue creada");
                setConflictoNoReply(null);
                resetearForm();
                getAreas();
                setLoading(false);
                onClose()
                handleUpdate()
            }).catch(err => {
                setLoading(false);
                if (err.response?.data?.status === "noReplyDuplicado") {
                    setConflictoNoReply({ ...err.response.data, body });
                } else if (err.response?.data?.status === "Hay integrantes que no existen") {
                    setMessage("Hay UIDs que no existen. No se pudo crear el área.")
                    setErrores(err.response.data.uids)
                } else {
                    setMessage("No se pudo crear el área.")
                }
            })
    }

    const resetearForm = () => {
        setValue({
            nombre: '',
            integrantes: [],
            observaciones: '',
            internos: [{ numero: '', especificacion: '' }],
            oficinas: [''],
            noReply: [],

        })
        setLoading(false);
    }

    function validateForm() {
        let validation = validationSchema.validate(value);
        if (validation.error) {
            let campo = validation.error.details[0].path[0];
            if (campo === 'internos') {
                if (validation.error.details[0].type === 'any.required') {
                    return 'Numero requerido';
                }
                return validation.error.message
            } else {
                return validation.error.details[0].path[0]
            }
        };

    }

    const validationSchema = Joi.object({
        path: Joi.string().required(),
        nombre: Joi.string().min(3).max(150).required(),
        integrantes: Joi.array().items(Joi.string().min(3).max(70).allow('')),
        observaciones: Joi.string().min(5).max(120).allow(''),
        noReply: Joi.array().items(
            Joi.string().email({ minDomainSegments: 2, tlds: { allow: ['ar', 'com', 'net'] } })
        ),
        oficinas: Joi.array().items(Joi.number().min(1).max(9999).allow('')),
        internos: Joi.array().items(Joi.object({
            especificacion: Joi.string().min(3).max(120).allow('').messages({
                'string.min': 'Limite de especificacion',
                'string.max': 'Limite de especificacion'
            }),
            numero: Joi.number().integer().min(1).max(99999).allow('').messages({
                'number.base': 'Numero requerido',
                'number.min': 'Limite de numero',
                'number.max': 'Limite de numero',
            }),
        }).custom((value, helpers) => {
            if (value.numero === '' && value.especificacion !== '') {
                return helpers.error('any.required');
            }
            return value;
        })).allow(null),

    });

    const mensajeAlertaFalloFormulario = (fallo) => {
        if (fallo === "path") setMessage("Es obligatorio seterar la ruta del área");
        if (fallo === "nombre") setMessage("El nombre debe tener entre 3 y 150 caracteres");
        if (fallo === "integrantes") setMessage("El uid debe tener entre 3 y 70 caracteres");
        if (fallo === "observaciones") setMessage("Las observaciones deben tener entre 5 y 120 caracteres");
        if (fallo === "noReply") setMessage("Hay una dirección no-reply con formato inválido");
        if (fallo === "oficinas") setMessage("La oficina debe ser un numero de entre 1 y 4 digitos");
        if (fallo === "Numero requerido") { setMessage("Debe agregar un numero de interno") };
        if (fallo === "Limite de numero") { setMessage("Los numeros del interno debe ser un numero de entre 1 y 5 digitos.") };
        if (fallo === "Limite de especificacion") { setMessage("Las especificaciones del interno deben tener entre 3 y 20 caracteres") };

    }

    const onChange = (e) => {
        setValue({
            ...value,
            [e.target.name]: e.target.value
        });

    }


    const lista = (item, tipo) => (
        <Grid item xs={window.screen.width < SIZE_MD ? 12 : 6}>
            <Zoom in={true}>
                <ListItem
                    key={tipo}
                    secondaryAction={
                        <IconButton
                            edge="end"
                            aria-label="delete"
                            onClick={() => {
                                if (tipo === 'I') {// integrantes
                                    handleClickRemoveIntegrante(item)
                                }
                                else if (tipo === 'O') {// oficina
                                    handleClickRemoveOficina(item)
                                }
                                else if (tipo === 'T') {// interno
                                    handleClickRemoveInterno(item)
                                }
                            }}
                            size="large">
                            <RemoveIcon />
                        </IconButton>
                    }
                >
                    <ListItemText
                        primary={<div style={styleLista}>{
                            tipo === 'T' ?
                                item.especificacion !== '' ?
                                    item.numero + ' - ' + item.especificacion : item.numero
                                : item}</div>}
                    />
                </ListItem>
            </Zoom>
        </Grid>
    )
    const obtenerPath = () => {
        if (areaPadre === null) return '/'
        else return areaPadre.path
    }


    return (
        <Box>
            {loading ?
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                    <CircularProgress color="secondary" />
                </div>
                :
                <>
                    <Grid container spacing={2}>
                        <Grid item xs={10} style={{ borderBottomColor: '#cfcfcf', borderWidth: '3%' }}>
                            <Typography align={'left'} className={classes.typography} variant={matches ? "h5" : "h4"}>
                                Crear Área
                            </Typography>
                        </Grid>
                    </Grid>
                    <CloseButton onClose={() => onClose()} />
                    <Form onSubmit={handleSubmit} >
                        <ModalContent dividers>
                            <Grid container>
                                <Grid item xs={12}>
                                    <TextFieldRojo
                                        id="outlined-read-only-input"
                                        label="Pertenece a"
                                        name="perteneceA"
                                        value={obtenerPath()}
                                        sx={{ my: 1 }}
                                        InputProps={{
                                            readOnly: true,
                                            disabled: true
                                        }}
                                        InputLabelProps={{
                                            classes: {
                                                root: classes.texto,
                                            },
                                        }} />
                                    <FormInput
                                        name="nombre"
                                        label="Nombre *"
                                        value={value.nombre}
                                        onChange={(e) => { onChange(e) }}
                                        onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                        fullWidth
                                        InputLabelProps={{
                                            classes: {
                                                root: classes.texto,
                                            },
                                        }}
                                    />
                                    <FormInput
                                        label={"Ingrese Integrante"}
                                        fullWidth
                                        onKeyPress={(e) => { e.key === 'Enter' && handleClickAddIntegrante() }}
                                        onChange={handleChangeI()}
                                        value={integrantes}
                                        error={alert ? alert.status === 'error' : false}
                                        InputProps={{
                                            endAdornment:
                                                <InputAdornment position="end">
                                                    <IconButton onClick={() => handleClickAddIntegrante()} size="large">
                                                        <AddIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                        }}
                                        InputLabelProps={{
                                            classes: {
                                                root: classes.texto,
                                            },
                                        }}
                                    />
                                    {value.integrantes.map((i) => lista(i, 'I'))}
                                    <br /> <br />
                                    <AlertMessage alert={alertOficina} setAlert={setAlertOficina} />
                                    <FormInput
                                        variant="outlined"
                                        label={"Ingrese Numero de Oficina"}
                                        fullWidth
                                        onKeyPress={(e) => { e.key === 'Enter' && handleClickAddOficina() }}
                                        onChange={handleChangeO()}
                                        value={oficina}
                                        error={alert ? alert.status === 'error' : false}
                                        InputProps={{
                                            endAdornment:
                                                <InputAdornment position="end">
                                                    <IconButton onClick={() => handleClickAddOficina()} size="large">
                                                        <AddIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                        }}
                                        InputLabelProps={{
                                            classes: {
                                                root: classes.texto,
                                            },
                                        }}
                                    />
                                    {value.oficinas.map((i) => lista(i, 'O'))}
                                    <br /> <br />
                                    <AlertMessage alert={alertInterno} setAlert={setAlertInterno} />
                                    <Grid container spacing={2} sx={{ flexGrow: 1 }} >
                                        <Grid item xs={4}>
                                            <FormInput
                                                variant="outlined"
                                                label={"Ingrese Numero de Interno"}
                                                fullWidth
                                                onChange={handleChangeTN()}
                                                value={numero}
                                                error={alert ? alert.status === 'error' : false}
                                                InputLabelProps={{
                                                    classes: {
                                                        root: classes.texto,
                                                    },
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={8}>
                                            <FormInput
                                                variant="outlined"
                                                label={"Ingrese Especificación"}
                                                fullWidth
                                                onKeyPress={(e) => { e.key === 'Enter' && handleClickAddInterno() }}
                                                onChange={handleChangeTD()}
                                                value={especificacion}
                                                error={alert ? alert.status === 'error' : false}
                                                InputProps={{
                                                    endAdornment:
                                                        <InputAdornment position="end">
                                                            <IconButton onClick={() => handleClickAddInterno()} size="large">
                                                                <AddIcon />
                                                            </IconButton>
                                                        </InputAdornment>
                                                }}
                                                InputLabelProps={{
                                                    classes: {
                                                        root: classes.texto,
                                                    },
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    {value.internos.map((i) => lista(i, 'T'))}
                                    <br /> <br />
                                    <FormInputMultiline
                                        name="observaciones"
                                        label="Observaciones"
                                        value={value.observaciones}
                                        onChange={(e) => { onChange(e) }}
                                        onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                        InputLabelProps={{
                                            classes: {
                                                root: classes.texto,
                                            },
                                        }}
                                    />
                                    <br /> <br />
                                    <CamposNoReply
                                        direcciones={value.noReply ?? []}
                                        onChange={(direcciones) => setValue({ ...value, noReply: direcciones })}
                                    />
                                </Grid>
                            </Grid>
                        </ModalContent>
                        <ModalActions>
                            <SaveButton label={"Crear Área"} onClick={handleSubmit} type="button" />
                        </ModalActions>
                    </Form>
                    <ConfirmarNoReplyDuplicado
                        conflicto={conflictoNoReply}
                        loading={loading}
                        onCancelar={() => setConflictoNoReply(null)}
                        onConfirmar={() => crearArea(conflictoNoReply.body, true)}
                    />
                </>}
        </Box>
    );
}